import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { theme } from 'assets/theme';
import ListItemComponent, { IStateListItem } from 'components/Abstract/ListItem';
import { IEntity } from 'interfaces/entity';
import { getStatusLabel } from 'interfaces/file';
import * as React from 'react';

import { getSituation } from '../../../Entity/Files/ListItem';
import { dateFormat } from '../../../../../../formatters/date';
import { getFileExpirationTime } from 'helpers/file';

interface IState extends IStateListItem {
  entityInfo: any;
}

interface IProps {
  file: any;
  entities: IEntity[];
}

export default class ListItem extends ListItemComponent<IProps, IState> {
  readonly tableRow = { height: theme.spacing(6) };

  componentDidMount = () => {
    const { entityId, tabId, subTabId } = this.props.file;
    const entity = this.props.entities.find((entity) => entity.id === entityId);
    const tab = this.props.entities.find((entity) => entity.id === tabId);
    const subTab = this.props.entities.find((entity) => entity.id === subTabId);

    return this.setState({
      entityInfo: {
        entity: entity ? entity.name : '',
        tab: tab ? tab.name : '',
        subTab: subTab ? subTab.name : '-',
      },
    });
  };

  render(): JSX.Element {
    const { entityInfo } = this.state;
    const { file } = this.props;

    if (!entityInfo) {
      return null;
    }

    return (
      <TableRow style={this.tableRow}>
        <TableCell>{entityInfo.entity}</TableCell>
        <TableCell align="right">{file.order}</TableCell>
        <TableCell>{entityInfo.tab}</TableCell>
        <TableCell>{entityInfo.subTab}</TableCell>
        <TableCell>{file.name}</TableCell>
        <TableCell>
          {file.url ? (
            <a target="_blank" rel="noopener noreferrer" href={file.url}>
              {file.filename}
            </a>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell>
          {file.emissionDate
            ? dateFormat(new Date(`${file.emissionDate}Z`))
            : '-'}
        </TableCell>
        <TableCell>
          {file.expirationDate
            ? dateFormat(new Date(`${file.expirationDate}Z`))
            : '-'}
        </TableCell>
        <TableCell>{getFileExpirationTime(file)}</TableCell>
        <TableCell>{file.frequency}</TableCell>
        <TableCell>{getStatusLabel(file.status)}</TableCell>
        <TableCell align="center">{getSituation(file)}</TableCell>
        <TableCell>
          {file.uploadDate ? dateFormat(new Date(`${file.uploadDate}Z`)) : '-'}
        </TableCell>
        <TableCell>
          {file.validationDate
            ? dateFormat(new Date(`${file.validationDate}Z`))
            : '-'}
        </TableCell>
      </TableRow>
    );
  }
}